var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-range-wrapper" }, [
    _c("div", { staticClass: "input-group date-group" }, [
      _c("input", {
        ref: "startInput",
        staticClass: "form-control",
        class: {
          "input-error-date": _vm.erroFormato.start,
          "input-valid-date": _vm.validoFormato.start,
        },
        attrs: {
          type: "text",
          name: "start",
          placeholder: _vm.dateOptions.placeholder,
          maxlength: _vm.dateOptions.format.length,
        },
        on: { input: _vm.processarValorInserido, blur: _vm.emitChange },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          ref: "calendarStartBtn",
          staticClass: "input-group-addon calendar-addon",
          on: {
            click: function ($event) {
              return _vm.abrirCalendario("start")
            },
          },
        },
        [_c("i", { staticClass: "fa fa-calendar" })]
      ),
    ]),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.onlyStart,
            expression: "!onlyStart",
          },
        ],
        staticClass: "ate-separator",
      },
      [_vm._v(" até ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.onlyStart,
            expression: "!onlyStart",
          },
        ],
        staticClass: "input-group date-group",
      },
      [
        _c("input", {
          ref: "endInput",
          staticClass: "form-control",
          class: {
            "input-error-date": _vm.erroFormato.end,
            "input-valid-date": _vm.validoFormato.end,
          },
          attrs: {
            type: "text",
            name: "end",
            placeholder: _vm.dateOptions.placeholder,
            maxlength: _vm.dateOptions.format.length,
          },
          on: { input: _vm.processarValorInserido, blur: _vm.emitChange },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            ref: "calendarEndBtn",
            staticClass: "input-group-addon calendar-addon",
            on: {
              click: function ($event) {
                return _vm.abrirCalendario("end")
              },
            },
          },
          [_c("i", { staticClass: "fa fa-calendar" })]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gerar-wrapper" },
      [
        _c("transition-group", { attrs: { name: "slide" } }, [
          _vm.gerarEnabled
            ? _c(
                "button",
                {
                  key: "enabledbuttondate",
                  staticClass: "btn blue",
                  attrs: { type: "button" },
                  on: { click: _vm.apply },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.buttonDescription) + "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.gerarEnabled
            ? _c(
                "button",
                {
                  key: "disabledbuttondate",
                  staticClass: "btn blue disabled",
                  attrs: { type: "button" },
                },
                [_vm._v("\n        Carregando\n      ")]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }